import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast, {});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
